module.exports = "/images/logoStand.png?3036cf522d1864d1fa623b21ed168626";